import script from "./Calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./Calendar.vue?vue&type=script&setup=true&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=71dab0a4&lang=css"

const __exports__ = script;

export default __exports__